import React, { useState } from 'react';
//@ts-ignore
import FileUpload, { FilePondServerType } from './FileUpload';
import * as FilePondType from './FilepondDefinitions';

type FileUploaderProps = {
  allowMultiple: boolean;
  allowImagePreview: boolean;
  onFileChange: (filePaths: FilePondType.FilePondFile[]) => void;
  allowPdfs?: boolean;
  token: string;
};

const FileUploader = ({
  allowMultiple,
  allowImagePreview,
  onFileChange,
  allowPdfs,
  token
}: FileUploaderProps): JSX.Element => {
  const [files, setFiles] = useState<FilePondType.FilePondFile[]>([]);

  const acceptedFileTypes = [
    'image/*',
    'image/heic',
    'image/heif',
    '.doc',
    '.docx'
  ];
  allowPdfs && acceptedFileTypes.push('application/pdf');

  const onFilesChanged = (files: FilePondType.FilePondFile[]) => {
    setFiles(files);

    if (files && files.length > 0) {
      onFileChange(files);
    } else {
      onFileChange([]);
    }
  };

  const onUploadError = (
    error: FilePondType.FilePondErrorDescription,
    file?: FilePondType.FilePondFile
  ) => {
    console.log(acceptedFileTypes);
    console.error(
      `file upload error: ${JSON.stringify(
        error
      )}, file: ${JSON.stringify(file)}`
    );
  };

  const authHeader = {
    Authorization: `Bearer ${token}`
  };

  const server: FilePondServerType = {
    url: './api/FileUpload/',
    revert: 'delete',
    process: 'upload',
    restore: null,
    load: null,
    fetch: null,
    headers: authHeader
  };

  return (
    <div>
      <FileUpload
        name='fileUploader1'
        labelIdle={`Drag & Drop your files or <span class=' filepond--label-action'> Browse </span>`}
        labelTapToCancel='Tap to cancel'
        labelFileProcessing='Uploading'
        labelFileProcessingComplete='Upload complete'
        labelTapToUndo='Tap to undo'
        allowMultiple={allowMultiple}
        allowImagePreview={allowImagePreview}
        maxFileSize={'10000000'}
        files={files}
        onFilesChanged={(files: FilePondType.FilePondFile[]) =>
          onFilesChanged(files)
        }
        server={server}
        onError={(
          error: FilePondType.FilePondErrorDescription,
          file: FilePondType.FilePondFile | undefined
        ) => onUploadError(error, file)}
        acceptedFileTypes={acceptedFileTypes}></FileUpload>
    </div>
  );
};

export default FileUploader;
